const ESTADOS = {
  AC: "ACRE",
  AL: "ALAGOAS",
  AP: "AMAPÁ",
  AM: "AMAZONAS",
  BA: "BAHIA",
  CE: "CEARÁ",
  DF: "DISTRITO FEDERAL",
  ES: "ESPÍRITO SANTO",
  GO: "GOIÁS",
  MA: "MARANHÃO",
  MT: "MATO GROSSO",
  MS: "MATO GROSSO DO SUL",
  MG: "MINAS GERAIS",
  PA: "PARÁ",
  PB: "PARAÍBA",
  PR: "PARANÁ",
  PE: "PERNAMBUCO",
  PI: "PIAUÍ",
  RJ: "RIO DE JANEIRO",
  RN: "RIO GRANDE DO NORTE",
  RS: "RIO GRANDE DO SUL",
  RO: "RONDÔNIA",
  RR: "RORAIMA",
  SC: "SANTA CATARINA",
  SP: "SÃO PAULO",
  SE: "SERGIPE",
  TO: "TOCANTINS",
};

// remove acentos
const normalize = (str) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();

export function validarEstado(input) {
  if (!input) {
    return {
      valido: false,
      motivo: "Estado não informado",
    };
  }

  const entrada = normalize(input);

  // 1. já é UF válida
  if (ESTADOS[entrada]) {
    return {
      valido: true,
      uf: entrada,
      nome: ESTADOS[entrada],
      normalizado: entrada,
    };
  }

  // 2. tentar mapear nome → UF
  const match = Object.entries(ESTADOS).find(
    ([, nome]) => normalize(nome) === entrada
  );

  if (match) {
    return {
      valido: true,
      uf: match[0],
      nome: match[1],
      normalizado: match[0],
    };
  }

  // 3. inválido
  return {
    valido: false,
    motivo: "Estado inválido",
    inputOriginal: input,
    normalizado: entrada,
  };
}